function showSelectedItems() {
  var amountAll = $('.list-item__row--body').length;
  var amountSelected = $('.list-item__row--body[data-selected="1"]').length;

  if (amountSelected == 0) {
    $('.list-multiselect__checkbox').attr('data-selected', 'none');
  } else if (amountSelected == amountAll) {
    $('.list-multiselect__checkbox').attr('data-selected', 'all');
  } else {
    $('.list-multiselect__checkbox').attr('data-selected', 'some');
  }
}

function selectItem(id) {
  var row = $('.list-item__row--body[data-id="' + id + '"]');
  var isSelected = row.attr('data-selected') == '1';
  row.attr('data-selected', isSelected ? '0' : '1');
  showSelectedItems();
}

function selectItems(el) {
  if ($(el).attr('data-selected') == 'all') {
    $('.list-item__row--body').attr('data-selected', '0');
  } else {
    $('.list-item__row--body').attr('data-selected', '1');
  }
  showSelectedItems();
}

function toggleMultiselectOptions() {
  var isOpen = $('.list-multiselect__options').hasClass(
    'list-multiselect__options--active'
  );
  isOpen ? closeMultiselectOptions() : openMultiselectOptions();
}

function openMultiselectOptions() {
  $('.list-multiselect__options').addClass(
    'list-multiselect__options--active'
  );

  $(document).on('click.multiselect', function (ev) {
    if (
      !$(ev.target).hasClass('list-multiselect__options') &&
      !$(ev.target).parents('.list-multiselect__options').length &&
      !$(ev.target).hasClass('list-multiselect__label')
    ) {
      closeMultiselectOptions();
    }
  });
}

function closeMultiselectOptions() {
  $('.list-multiselect__options').removeClass(
    'list-multiselect__options--active'
  );
  $(document).off('click.multiselect');
}

function getSelectedIds() {
  var ids = [];
  $('.list-item__row--body[data-selected="1"]').each(function (index, item) {
    ids.push($(item).attr('data-id'));
  });
  return ids;
}

function getMultiSelectSuccessMessage(ids, text) {
  if (ids.length == 1) {
    var successMessage = $('.list-items__wrapper').attr('data-name-single');
  } else {
    var successMessage =
      ids.length + ' ' + $('.list-items__wrapper').attr('data-name-plural');
  }
  successMessage += ' ' + text;

  return successMessage;
}

function getMultiSelectRowsSelector(ids) {
  var selector = '';
  $.each(ids, function (index, id) {
    if (index > 0) {
      selector += ', ';
    }
    selector += '.list-item__row[data-id="' + id + '"]';
  });
  return selector;
}
